import React from "react";
import styles from "./PropertyTypes.module.css";
import apart from "../../images/apart.png";
import single from "../../images/single.png";

interface PropertyCardProps {
  title: string;
  description: string;
  imageUrl: string;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
  title,
  description,
  imageUrl,
}) => (
  <div className={styles.card}>
    <div className={styles.cardContent}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
    </div>
    <div className={styles.imageContainer}>
      <img src={imageUrl || ""} alt={title} className={styles.image} />
    </div>
  </div>
);

const PropertyTypes: React.FC = () => {
  const properties = [
    {
      title: "Multifamily",
      description:
        "Whether you own a duplex, fourplex, or a 25+ unit building, our enterprise-grade platform gives you the power to manage it all—effortlessly. Stay organized, maximize profits, and focus on what you do best.",
      imageUrl: apart,
    },
    {
      title: "Single Family",
      description:
        "Easily manage your single-family rentals like a pro. Keep track of tenants, rent payments, and maintenance—all in one seamless platform built for independent landlords.",
      imageUrl: single,
    },
    {
      title: "Small Landlord, Big Control",
      description:
        "Manage your business like an institution with Enterprise Level software built to help you.",
      imageUrl: single,
    },
    {
      title: "Pro Landlord, Maximum Efficiency",
      description:
        "Take your rental business to the next level with enterprise-grade tools designed for serious landlords. Automate, optimize, and grow with ease.",
      imageUrl: apart,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {properties.map((property, index) => (
          <PropertyCard
            key={index}
            title={property.title}
            description={property.description}
            imageUrl={property.imageUrl}
          />
        ))}
      </div>
    </div>
  );
};

export default PropertyTypes;
